// extracted by mini-css-extract-plugin
export default {"loading":"IsLoading_loading__vvO5A"};